import axios from "axios";

export default {
    data() {
        return {
            introductionData: null,
        };
    },
    methods: {
        getIntro() {
            axios
                .get(
                    `/api/maps/${this.mapData.id}/introduction?locale=${this.mapData.current_locale}`
                )
                .catch(function (error) {
                    console.log(error.toJSON());
                })
                .then((response) => {
                    this.introductionData = response.data;
                    if (this.introductionData &&
                        this.introductionData.is_default_open) {
                        this.openSubSidebar('introductionBox');
                    }

                    if (Object.keys(this.introductionData).length == 0) {
                        this.introductionData = null;
                    }
                });
        },
    },
    created() {
        this.getIntro();
    },
};
